export const TextSection = ({ content, className, margin = 'mt-12' }: { content: React.ReactNode, className?: string, margin?: string }) => {
  return (
    <div className={`mx-auto px-4 ${className} ${margin} pb-14`}>
      <article className="prose mx-auto text-base font-serif container">{content}</article>
    </div>
  );
};
